import { BimBuildingaddress } from "../models/bim-buildingaddress";
import { BimBuildingCamera } from "../models/bim-building-camera";
import { BimBuildingCompass } from "../models/bim-building-compass";

export abstract class XprojBimBuildingService {
  abstract getBimBuildingaddresses(buildingId: number) : Promise<BimBuildingaddress[]>;

  abstract setBimBuildingaddresses(buildingId: number, bimBuildingAddresses : BimBuildingaddress[], customerId : string) : Promise<boolean>;

  abstract getBimCamera(buildingId: number, forceReload : boolean) : Promise<BimBuildingCamera>;

  abstract setBimCamera(buildingId: number, bimBuildingCamera : BimBuildingCamera, customerId : string) : Promise<boolean>;

  abstract getBimCompass(buildingId: number, forceReload : boolean) : Promise<BimBuildingCompass>;

  abstract setBimCompass(buildingId: number, bimBuildingCamera : BimBuildingCompass, customerId : string) : Promise<boolean>;

}
